module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/scymfF/images/cover.png?1684514921957",
      "alt": "This image is the cover for the book Bittersweet Promises (Daring Western Hearts Series, Book 2), Daring Western Hearts Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bittersweet Promises (Daring Western Hearts Series, Book 2), Daring Western Hearts Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Heiress Declares Gun-Toting Southern Gentleman Mannerless in "), _c('i', [_vm._v("Bittersweet Promises")]), _vm._v(", by Trana Mae Simmons")]), _c('br'), _c('br'), _c('i', [_vm._v("February 13, 1866, Liberty, Missouri and Missouri Ozarks")]), _c('br'), _vm._v("Cody Garret likes everything in its place: his horse in the corral, his six-gun in his holster, and his money in the bank. There's no way on earth he can tolerate a woman like Shanna Van Alstyne. With a spirit as fiery as the blazing sun, she has a temper to match."), _c('br'), _vm._v("Unfortunately, southern manners dictate he save her life, but then she's on her own--until a daring robbery throws the infuriating woman back into his arms, again."), _c('br'), _c('br'), _c('b', [_vm._v("REVIEWS:")]), _c('br'), _vm._v("\"Tender, humorous, and poignant read.\" ~Gail Collins, Romantic Times Magazine"), _c('br'), _c('br'), _c('b', [_vm._v("The DARING WESTERN HEARTS SERIES")]), _vm._v(", in order "), _c('br'), _c('i', [_vm._v("Montana Surrender"), _c('br'), _vm._v("Bittersweet Promises"), _c('br'), _vm._v("Mountain Magic")]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Trana Mae Simmons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Trana Mae Simmons talks to unseen people, loses herself in other lives for hours, and writes down her imaginative journeys for others to enjoy. Residing in historical East Texas with her family and pets, Trana loves to explore the paths less traveled.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ePublishing Works!\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0